/* eslint-disable react/display-name */

import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button
} from "reactstrap"
import DatatableTables from "components/tables/DatatableTables";
import { get } from 'helpers/api_helper'
import { REPORTS_URL } from 'helpers/url_helper'
import moment from 'moment'
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"
import uuid4 from "uuid4";

const Timezone = (dateString) => {    
  const date = moment(dateString).toDate();
  return moment(date).format('YYYY-MM-DD');;
}

const Reports = () => {
    const [data, setData] = useState([])
    const [filters, setFilters] = useState({
      diner_type: '',
      dine_type: '',
      date: [moment().format('yyyy-MM-DD')]
    })

    const fetchData = async() => {
      const queryString = new URLSearchParams(filters).toString();
      const res = await get(`${REPORTS_URL}/token?${queryString}`);
      if(res.success){
        setData([])
        setData(res.body)
      }
    }

    const columns = [{
      dataField: 'id',
      text: '#',
      sort: true,
    },{
      dataField: 'token_no',
      text: 'Token #',
      sort: true,
      formatter: (cell, row) => <b className='text-denger'>{row.token_no}</b>
    },{
      dataField: 'name',
      text: 'Name',
      sort: true
    },{
      dataField: 'dinner_code',
      text: 'Dinner Code',
      sort: true
    },{
      dataField: 'meal_type',
      text: 'Meal Type',
      sort: true
    },{
      dataField: 'diner_type',
      text: 'Diner Type',
      sort: true        
    },{
      dataField: 'dine_date',
      text: 'Dine Date',
      formatter: (cell, row) => <b className='text-denger'>{row.dine_date}</b>
    },{
      dataField: 'dine_time',
      text: 'Dine Time',
      formatter: (cell, row) => <b className='text-denger'>{row.dine_time}</b>
    }]

    useEffect(() =>{
        fetchData();
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Reports | Advance Dental Export Canteen Management</title>
                </MetaTags>
                <Container fluid>
                  <Row>
                    <Col>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col>
                              <label>Dine Type</label>
                              <select className="form-control" defaultValue={filters?.dine_type} onChange={(e) => setFilters(prev => ({...prev, dine_type:e.target.value}))}>
                                <option value="" >Both</option>
                                <option value="1" >Lunch</option>
                                <option value="2" >Dinner</option>
                              </select>
                            </Col>
                            <Col>
                              <label>Diner Type</label>
                              <select className="form-control" defaultValue={filters?.diner_type} onChange={(e) => setFilters(prev => ({...prev, diner_type:e.target.value}))}>
                                <option value="" >All</option>
                                <option value="1" >Employees</option>
                                <option value="2" >Guests</option>
                                <option value="3" >Temporary Employees</option>
                              </select>
                            </Col>
                            <Col>
                              <label>Date Wise</label>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="DD-MM-YYYY"
                                options={{
                                    mode: "range",
                                    dateFormat: "d-m-Y"
                                }}
                                defaultValue={moment().format('DD-MM-YYYY')}
                                onChange={
                                    (e) => {
                                        const dates = e.map(dateString => Timezone(dateString));
                                        setFilters(prev => ({...prev, date:dates}))
                                    }
                                }
                            />
                            </Col>
                            <Col className="text-start">
                              <Button className="btn btn-success" onClick={fetchData} style={{width: '120px', marginTop: '28px'}}>Filter</Button>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {
                    Object.keys(data)?.length ? 
                    <>
                      <Row>
                        {
                          data?.totals?.map((v, i) => (
                            <div className="col-md-4" key={`${uuid4()}_${i+1}`}>
                              <div className="mini-stats-wid card">
                                  <div className="card-body">
                                      <div className="d-flex">
                                          <div className="flex-grow-1">
                                              <p className="text-muted fw-medium">{v.type} Tokens</p>
                                              <h4 className="mb-0">{v.count.toString().padStart(3, '0')}</h4>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          ))
                        }
                        {
                          data?.tokens?.map((v, i) => (
                            <div className="col-md-2" key={`${uuid4()}_${i+1}`}>
                              <div className="mini-stats-wid card">
                                  <div className="card-body">
                                      <div className="d-flex">
                                          <div className="flex-grow-1">
                                              <p className="text-muted fw-medium">{v.type}</p>
                                              <h4 className="mb-0">{v.count.toString().padStart(3, '0')}</h4>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          ))
                        }
                      </Row>
                      <DatatableTables
                        key={'id'}
                        title={`Tokens Issued Report`}
                        columns={columns || []}
                        csv_filename={`ade_tokens_report_${moment().format('YYYY-MM-DD')}`}
                        rows={data?.dinners || []} />
                    </> : ''
                  }
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Reports;
